<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addNewKind">新增分组</el-button>
        <!-- <el-button size="small" @click="filter">筛选分组</el-button> -->
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="分组名称" prop="PROJECT_GROUP"></el-table-column>
          <el-table-column label="操作" min-width="50px">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="skuProduct(scope.row)">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="editProduct(scope.row)">修改</el-button>
              <el-button type="text" size="small" icon="el-icon-close" style="color: rgb(245, 108, 108)" @click="deleteProduct(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <!-- 增加分组 -->
        <el-dialog title="新增分组" center :visible.sync="addFormVisible" width="600px">
          <el-form size="small" :model="addForm" ref="addForm">
            <el-form-item label="分组名称：" :label-width="formLabelWidth">
              <el-input v-model="addForm.Name"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitAdd" v-if="this.addForm.Name === ''" disabled>确 定</el-button>
            <el-button size="small" @click="submitAdd" v-else>确 定</el-button>
          </div>
        </el-dialog>
        <!-- 修改模态框 -->
        <el-dialog title="修改分组" center :visible.sync="editFormVisible" width="600px">
          <el-form size="small" :model="editForm" ref="editForm">
            <el-form-item label="分组名称：" :label-width="formLabelWidth">
              <el-input v-model="editForm.PROJECT_AREA"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitEdit()">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 筛选模态框 -->
        <!-- <el-dialog title="筛选分组" center :visible.sync="filterFormVisible" width="400px">
                        <el-form size="small" :model="filterForm" ref="filterForm">
                            <el-form-item label="分组名称：" :label-width="formLabelWidth">
                                <el-select filterable v-model="filterForm.CUSTOMER">
                                    <el-option v-for="item in tableData" :key="item.GROUP_ID" :value="item.GROUP_ID" :label="item.CLIENT_GROUP"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button size="small" @click="filterFormVisible = true">取 消</el-button>
                            <el-button size="small" @click="filterGroup">确 定</el-button>
                        </div>
                    </el-dialog> -->
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  addClientGroupFun, deleteClientGroupFun, editClientGroupFun, getClientGroupFun,
} from 'api/systemSetting';

export default {
  data() {
    return {
      tableData: [],
      addForm: {
        Name: '',
      },
      // filterForm: {
      //     CUSTOMER: ''
      // },
      // loading: false,
      addFormVisible: false,
      // filterFormVisible: false,
      formLabelWidth: '120px',
      editForm: {},
      editFormVisible: false,
    };
  },
  created() {
    this.queryTable();
  },
  methods: {
    addNewKind() {
      this.addFormVisible = true;
    },
    editProduct(row) {
      this.editFormVisible = true;
      this.editForm = row;
      sessionStorage.setItem('GROUP_ID', row.GROUP_ID);
    },
    skuProduct(row) {
      this.$router.push({ name: 'matchClientGroup' });
      sessionStorage.setItem('GROUP_ID', row.GROUP_ID);
    },
    filter() {
      this.filterFormVisible = true;
      this.queryTable();
    },
    // ---------------------------筛选分组
    // filterGroup() {
    //     if(document.body.style.cursor==="wait"){
    //         return;
    //     }else{
    //         document.body.style.cursor="wait";
    //         try{
    //             let params = {
    //                 CLIENT_GROUP: this.filterForm.CUSTOMER
    //             }
    //             filterGroupFun(params).then(result => {
    //                 this.$router.push({name: 'matchClientGroup'})
    //                 this.$message.show({text: '筛选成功', type: 'success'})
    //                 this.filterFormVisible = false
    //                 this.filterForm = {}
    //             })
    //         }
    //     }
    // },
    // --------------------------添加分组
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            PROJECT_GROUP: this.addForm.Name,
          };
          addClientGroupFun(params)
            .then((result) => {
              this.$message.show({ text: '新增品类成功', type: 'success' });
              this.addFormVisible = false;
              this.addForm = {};
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {}
      }
    },
    // ------------------------------------删除功能
    deleteProduct(row) {
      sessionStorage.setItem('GROUP_ID', row.GROUP_ID);
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            GROUP_ID: row.GROUP_ID,
          };
          deleteClientGroupFun(params)
            .then((result) => {
              this.$message.show({ text: '删除成功', type: 'success' });
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {}
      }
    },
    // -----------------------------------修改功能
    submitEdit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            PROJECT_GROUP: this.editForm.PROJECT_AREA,
          };
          if (!this.editForm.PROJECT_AREA) {
            this.$message.show({ text: '请输入分组名称', type: 'warning' });
            return false;
          }
          editClientGroupFun(params)
            .then((result) => {
              this.$message.show({ text: '修改品类成功', type: 'success' });
              this.editFormVisible = false;
              this.editForm = {};
              this.queryTable();
              // this.loading = false
              document.body.style.cursor = 'default';
            }).catch((error) => {
              // this.loading = false
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {}
      }
    },
    close() {
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.addForm = {};
    },
    // -----------------------------------进入页面拉取数据
    queryTable() {
      getClientGroupFun().then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange() {
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customerManage/clientGroup.vue